import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const GrantDetails2 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className={`${styles["grant-list"]} padding`}>
					<div className={styles.category}>복지로 <i className="tag tag-round tag-blue ml_5">70% 적합</i></div>
					<p className={`${styles.title} mt_10`} style={{ fontSize: "1.8rem" }}>가정양육수당 지원</p>
					<div className={`${styles["tag-group"]} mt_10`}>
						<span>#다자녀</span>
						<span>#미취학아동</span>
						<span>#자녀나이3세</span>
					</div>
					<div className={`${styles.price} mt_20`}><strong>10</strong> 만원</div>
					<div className={`${styles["detail-box"]} mt_20 mb_0`}>
						<ul className="list-item" style={{ fontSize: "1.4rem" }}>
							<li>
								<span>생애주기</span>
								<span>영유아, 아동, 임신출산</span>
							</li>
							<li>
								<span>대상특성</span>
								<span>소년소녀 가장가구</span>
							</li>
							<li>
								<span>장애유형</span>
								<span>지체(전환대상)</span>
							</li>
							<li>
								<span>가구유형</span>
								<span>다문화ㆍ탈북민</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding">
					<h3>기관정보</h3>
					<ul className="list-item mt_30">
						<li>
							<span>소관부처</span>
							<span>보건복지부 보육사업기획과</span>
						</li>
						<li>
							<span>문의처</span>
							<span>보건복지부 콜센터</span>
						</li>
					</ul>
					<div className="flex-justify_end mt_10">
						<div className={styles["list-btn"]}>고객센터</div>
						<div className={`${styles["list-btn"]} ml_10`}>홈페이지</div>
					</div>
				</div>
			</div>
			<div className="no-scroll pt_30" style={{ overflowX: "auto" }}>
				<ul className="tab-round no-wrap">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>지원내용</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>지원대상</li>
					<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>선정기준</li>
					<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>신청방법</li>
					<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>기타</li>
				</ul>
			</div>
			<div className="padding pt_20">
				<ul className={styles["explain-list"]}>
					<li>
						<div className={styles.title}>서비스 요약</div>
						<ul>
							<li>◦ 입국초기 결혼이민자의 초기 정착 단계에서 경험하는 의사소통 문제해결을 위한 통번역서비스 지원으로 한국사회 조기 적응에 기여</li>
							<li>◦ 통·번역 인력채용 등 사회적 일자리 확대로 결혼이민자의 자립능력 및 주체적 역량 강화</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>서비스 내용</div>
						<ul>
							<li>
								<p>발급대상</p>
								<p>◦ 「독립유공자 예우에 관한 법률 」,「국가유공자 등 예우 및 지원에 관한 법률」및 「보훈보상대상자 지원에 관한 법률」의 적용을 받고 있는 자와 그 가족으로서 국가보훈처장이 의료급여가 필요하다고 요청한 자중 보건 복지부장관이 의료급여가 필요하다고 인정한 자</p>
							</li>
							<li>
								<p>◦ 국가보훈처장 추천 후, 보건복지부 장관이 의료급여가 필요하다고 인정한 경우 의료급여증을 발급</p>
								<p>- 개인의 질병, 부상 등에 대한 의료서비스 제공(진찰, 검사, 약제, 치료재료 지급, 수술, 입원 등)</p>
							</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>지원대상</div>
						<p>긴급지원대상자 중 가구구성원이 사망한 경우 사체의 검안,운반,화장 또는 매장 기타 장제조치를 행하는데 필요한 비용 지원</p>
					</li>
					<li>
						<div className={styles.title}>선정기준</div>
						<ul>
							<li>
								<p>◦ 그 밖의 연장형 보육료 지원대상은 만0~2세 연장보육료(기본보육시간 보육료 지원아동은 휴일보육료만 지원가능), </p>
								<p>- 만 3~5세 누리과정보육료, 다문화보육료 및 장애아보육료(취학전) 지원아동을 원칙으로 함.  다만, 만12세 이하 취학</p>
								<p>- 아동 중 법정저소득층과 장애아동(복지카드소지자)*에 대해서는 야간연장 보육료에 한하여 지원가능</p>
								<p>* 복지카드미소자인 취학 장애아동은 특수교육대상자 진단？평가 통지서 제출시 만 8세까지 지원</p>
							</li>
							<li>◦ 야간12시간보육료, 24시간 보육료는 24시간 지정 어린이집을 이용하는 경우만 지원 가능</li>
							<li>◦ 기타 기준 : 원장 겸 교사의 자녀에 대해서는 그 밖의 연장형 보육료를 지원하지 않음</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>신청방법</div>
						<p>거주지 읍/면/동 주민센터</p>
					</li>
					<li>
						<div className={`${styles.title} flex-justify_between align_center`}>
							<div>서식자료</div>
							<span className={styles["btn-txt"]}>홈페이지</span>
						</div>
						<p>서식자료명</p>
					</li>
					<li>
						<div className={`${styles.title} flex-justify_between align_center`}>
							<div>근거법령</div>
							<span className={styles["btn-txt"]}>홈페이지</span>
						</div>
						<p>근거법령명</p>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default GrantDetails2
